module.exports = __webpack_public_path__ + "static/media/sourdoughsimplified.67b218ac.jpg";